import { ACNE_ROSACEA, INGREDIENTS } from './ingredients-info';
import type { IngredientsProps } from '../Ingredients';

export const INGREDIENTS_NEUTRAL_CONTENT: IngredientsProps = {
  header:
    'Get the powerful ingredients dermatologists prescribe—and use—themselves',
  ingredients: INGREDIENTS[ACNE_ROSACEA],
};
